import React, { useState, useEffect } from "react";
import { GoogleLogin } from '@react-oauth/google';
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import leftImage from './images/banniere.jpg';
import ms from './images/ms.png';
import pmp from './images/logo-pmp.png';
import useAuthCon from "../dashboard/useAthCon";
import LoadingSpinner from "./loading";

const Connexion = () => {
  useAuthCon();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const shoppingImage = "/assets/images/ecom3.png";
  // ****************************************** PA-3 **************************************************

  const handleGoogleLogin = async (credentialResponse) => {
    setIsLoading(true);

    // ****************************************** PA-4 **************************************************
    try {
      const decoded = jwtDecode(credentialResponse?.credential);
      const user = decoded;

      const response = await fetch(process.env.REACT_APP_HOTE + '/connexion-google/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: user.email,
          given_name: user.given_name,
          family_name: user.family_name,
        }),
      });

      const result = await response.json();

      // ************************************ PA-6 ***************************************
      if (response.ok) {
        const userId = result.user_id;
        const tokenCle = result.acces;
        const group_id = result.group_id;

        localStorage.setItem('access_token', tokenCle);

        // ************************************ PA-7 ***************************************
        if (userId) {
          localStorage.setItem('IDDDD', userId);
          localStorage.setItem('groupe', group_id); // PA-8
          navigate(`/activation-page`, { state: { user, userId } });
        } else {
          setError("L'ID utilisateur est manquant.");
        }
      } else {
        const userId = result.user_id;
        const tokenCle = result.acces;
        const group_id = result.group_id;

        if (userId) {
          localStorage.setItem('access_token', tokenCle);
          localStorage.setItem('IDDDD', userId);
          localStorage.setItem('groupe', group_id);

          // Récupérer la redirection après connexion
          const redirectTo = localStorage.getItem('redirectAfterLogin') || '/papachigan';
          localStorage.removeItem('redirectAfterLogin');

          // Si un produit était sélectionné avant la connexion
          const produitSelectionne = localStorage.getItem('produitSelectionne');
          if (produitSelectionne) {
            localStorage.removeItem('produitSelectionne');
            navigate('/Detail-produit', {
              state: { produit: JSON.parse(produitSelectionne) }
            });
          } else {
            navigate(redirectTo);
          }
        } else {
          setError("Cette adresse mail est invalide. Veuillez réessayer avec un autre mail.");
        }
      }
    } catch (error) {
      // ******************************************PA-5 ********************************
      console.error('Erreur lors de la connexion Google:', error);
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  const errorMessage = (error) => {
    console.log('Erreur de connexion Google:', error);
    setError('Échec de la connexion avec Google. Veuillez réessayer.');
  };

  const errorStyle = {
    color: 'red',
    fontSize: '14px',
    marginTop: '10px',
  };

  const imageStyle = {
    width: '100%',
    height: '120px',
    objectFit: 'cover',
    objectPosition: 'center 90%', // Ajustez ce pourcentage pour rogner comme vous voulez
  };

  const [formation, setFormation] = useState([]);
  // Fetching formations data from API
  const fetchFormation = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
      if (response.ok) {
        const data = await response.json();
        console.log(data)
        setFormation(data);
      } else {
        console.error('Erreur lors de la récupération des formations');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };
  useEffect(() => {
    fetchFormation();
  }, []);



  const currentDate = new Date();

  const upcomingFormations = formation.filter(formation => {
    const [day, month, year] = formation.date.split('/papachigan').map(Number);
    const formationDate = new Date(year, month - 1, day);
    return formationDate >= currentDate;
  });



  // Appliquer le style maxHeight conditionnellement si plus de 3 formations
  const scrollStyle = {
    maxHeight: upcomingFormations.length > 3 ? '330px' : 'auto',
    overflowY: upcomingFormations.length > 3 ? 'auto' : 'visible'
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="loginColumns animated fadeInDown">
          <div className="row complet d-flex justify-content-center">

            <div className="col-md-6 mb-0 gauche" style={{ backgroundColor: '#ffffff' }}>
              <div className="mt-4">
                <img src={shoppingImage} alt="Achats en ligne" className="img-fluid" style={imageStyle} />
                <h2 class="font-bold text-center">PAYME</h2>
                <p class="mt-4 text-center">
                  La plateforme incontournable pour vos produits et services de qualité.
                </p>
                <div className="bouton-google mt-5">
                  {/*--------------- PA-1 --------------------*/}
                  <GoogleLogin onSuccess={handleGoogleLogin} onError={errorMessage} />
                </div>
                {error && <p style={errorStyle}>{error}</p>}
              </div>

            </div>
          </div>
          <div className="row">
            <div class="col-md-12 w-100 text-center">
              <small>Inovact &copy; 2025. Tous droits réservés.</small>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Connexion;
